import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import PermissionCreate from "../../../components/CreateForm";
import { clearValues, createPermission } from "./actions";

function Create({ history }) {
	const dispatch = useDispatch();

	const { loading } = useSelector(s => s.permissionCreate);
	const permission_create = useSelector(s => s.form.permission_create);

	useEffect(() => {
		dispatch(clearValues());
	}, []);

	const onSubmit = data => {
		dispatch(
			createPermission(
				{
					name: data.name,
					description: data.description
				},
				err => {
					if (err) {
						console.log(err);
						if (err.code) {
							alert(err.code);
						} else if (typeof err === "string") alert(err);
						else alert(JSON.stringify(err));
					} else {
						history.push("/permission");
					}
				}
			)
		);
	};

	return (
		<Container className="dashboard">
			<Row>
				<Col xs={12}>
					<Card>
						<div className="card__title">
							<h4 className="bold-text">Cadastrar nova permissão</h4>
						</div>
						<CardBody>
							<PermissionCreate
								onSubmit={onSubmit}
								loading={loading}
								isInvalid={permission_create && !!permission_create.syncErrors}
							/>
						</CardBody>
					</Card>
				</Col>
			</Row>
		</Container>
	);
}

export default Create;
